<div class="dialog-form user-access">
  <p class="subtitle" *ngIf="userName">Permissões de ação de <strong>{{ userName }}</strong> nesta marina</p>

  <div class="profile-options">
    <label><input type="radio" name="profile" value="ADMIN" [(ngModel)]="profile"> Admin (acesso total)</label>
    <label><input type="radio" name="profile" value="VIEWER" [(ngModel)]="profile"> Visualização (somente consulta)</label>
    <label><input type="radio" name="profile" value="CUSTOM" [(ngModel)]="profile"> Personalizado (por ação)</label>
  </div>

  <div class="capabilities" *ngIf="isCustom">
    <div class="category" *ngFor="let group of categories">
      <div class="category-header">
        <strong>{{ group.name }}</strong>
        <span class="category-actions">
          <a href="javascript:void(0)" (click)="toggleCategory(group, true)">marcar tudo</a> ·
          <a href="javascript:void(0)" (click)="toggleCategory(group, false)">limpar</a>
        </span>
      </div>
      <label class="capability" *ngFor="let cap of group.caps">
        <input type="checkbox" [(ngModel)]="selected[cap.code]" [name]="cap.code">
        {{ cap.description }}
      </label>
    </div>
  </div>

  <div class="buttons">
    <button class="easymarine danger" type="button" (click)="ref.close()">{{ 'CANCEL' | translate }}</button>
    <button class="easymarine primary" type="button" (click)="save()">{{ 'SAVE' | translate }}</button>
  </div>
</div>
